import React from "react";
import { ListFieldProps } from "@sitecore-jss/sitecore-jss-react-forms";
import { DropdownListViewModel } from "@sitecore-jss/sitecore-jss-forms";

const DropDown = (props: ListFieldProps<DropdownListViewModel>) => {
  var options = props.field.model.items.map((x, i) => (
    <option value={x.value} key={i}>
      {x.text}
    </option>
  ));


  return <select>{options}</select>;
};

export default DropDown;
